import { Box, styled, TextField } from '@mui/material';
import { CustomIcon } from 'components/mrp/mrp.styles';

export const EntitySearchTextField = styled(TextField)(({ theme }) => ({
  width: `calc(100% - ${theme.spacing(4)})`,
  padding: theme.spacing(2)
}));

export const EntitySearchIcon = styled(CustomIcon)(({ theme }) => ({
  marginRight: theme.spacing(1)
}));

export const EntityOptionRow = styled(Box, {
  shouldForwardProp: (prop: string) => !['columnWidths'].includes(prop)
})<{
  columnWidths: (string | number)[];
}>(({ theme, columnWidths = [] }) => ({
  display: 'grid',
  gridTemplateColumns:
    columnWidths
      .map((width) => (typeof width === 'number' ? `${width}px` : width))
      .join(' ') || '1fr',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(1, 0)
}));

export const EntityOptionColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minWidth: 0,
  width: '100%',
  padding: theme.spacing(1, 0),
  overflowWrap: 'anywhere'
}));
